var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAthletics = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Athletics-Running--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Athletics Running Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13 7h0.5a0.5 0.5 0 0 0 0.5 -0.5V4.75a0.5 0.5 0 0 0 -0.5 -0.5h-1.21a7.75 7.75 0 0 0 0 15.5h1.21a0.5 0.5 0 0 0 0.5 -0.5V17.5a0.5 0.5 0 0 0 -0.5 -0.5H13a5 5 0 0 1 0 -10Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 4.75V6.5a0.5 0.5 0 0 0 0.5 0.5h7.5a0.5 0.5 0 0 0 0.5 -0.5V4.25h-8a0.5 0.5 0 0 0 -0.5 0.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 0h-3.75a0.5 0.5 0 0 0 -0.5 0.5v1.75a0.5 0.5 0 0 0 0.5 0.5H24V0.5a0.5 0.5 0 0 0 -0.5 -0.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 17H18a0.5 0.5 0 0 1 -0.5 -0.5v-1a0.5 0.5 0 0 1 0.3 -0.45l3.61 -1.61a1 1 0 0 0 0 -1.82l-4.5 -2a1 1 0 0 0 -1.41 0.91v10.22a0.5 0.5 0 0 1 -0.5 0.5h-2.71a9.25 9.25 0 0 1 0 -18.5h5a0.5 0.5 0 0 0 0.5 -0.5V0.5a0.5 0.5 0 0 0 -0.5 -0.5H12a12 12 0 0 0 0 24h11.5a0.5 0.5 0 0 0 0.5 -0.5v-1.75a0.5 0.5 0 0 0 -0.5 -0.5H18a0.5 0.5 0 0 1 -0.5 -0.5v-0.5a0.5 0.5 0 0 1 0.5 -0.5h5.5a0.5 0.5 0 0 0 0.5 -0.5V17.5a0.5 0.5 0 0 0 -0.5 -0.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAthletics);
export default ForwardRef;